/* src/components/pdf-page-quickscan-list/pdf-page-quickscan-list.component.scss */
app-pdf-page-quickscan-questions {
  display: block;
}
/*# sourceMappingURL=pdf-page-quickscan-list.component-YMNCX5HP.css.map */
